import { createReducer } from "@reduxjs/toolkit";
import initialState from "./initialState";
import * as types from "../types/actions";
import moment from "moment";
import _ from "lodash";

const checkinReducer = createReducer(initialState.checkin, {
  [types.CHECKIN]: (state) => ({
    ...state,
    loading: true,
  }),
  [types.CHECKIN_FAILURE]: (state, action) => ({
    ...state,
    toast: {
      type: "error",
      // message: "Failed to login: " + action?.error,
      message: action?.error,
    },
    loading: false,
  }),
  [types.CHECKIN_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    surname: action.response.data.FrontDeskSearchReservation.Surname,
    resNo: action.response.data.FrontDeskSearchReservation.ResNo,
    resType: action.response.data.FrontDeskSearchReservation.ResType,
    confNo: action.response.data.FrontDeskSearchReservation.ConfNo,
    country: action.response.data.FrontDeskSearchReservation.Country,
    LicenceNumber: action.response.data.FrontDeskSearchReservation.LicenceNumber,
    PrePaid: action.response.data.FrontDeskSearchReservation.PrePaid,
    OtherID: action.response.data.FrontDeskSearchReservation.OtherID,
    verifyCC: action.response.data.FrontDeskSearchReservation.VerifyCC,
    verifyID: action.response.data.FrontDeskSearchReservation.VerifyID,
    hasSMSSendRecord: action.response.data.FrontDeskSearchReservation.SmsSentToAddDriverSuccess,
    checkinStatus: action.response.data.FrontDeskSearchReservation.CheckinStatus,
    additionalDriverIdVerified:
      action.response.data.FrontDeskSearchReservation.AdditionalDriverIdVerified,
  }),

  [types.CHECKIN_GENERIC]: (state) => ({
    ...state,
    loading: true,
  }),

  [types.SET_IS_GENERIC_CHECKIN]: (state, action) => ({
    ...state,
    isGenericCheckin: action.payload.isGenericCheckin,
  }),

  [types.CHECKIN_GENERIC_FAILURE]: (state, action) => ({
    ...state,
    toast: {
      type: "error",
      // message: "Failed to login " + action?.error,
      message: action?.error,
    },
    loading: false,
  }),
  [types.CHECKIN_GENERIC_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    brand: action.response.data.GenericCheckinSearch.Brand,
    checkinStatus: action.response.data.GenericCheckinSearch.CheckinStatus,
    toast: !action.response.data.GenericCheckinSearch.Success
      ? {
          type: "error",
          message: action.response.data.GenericCheckinSearch.Error,
        }
      : state.toast,
  }),

  [types.CHECKOUT]: (state) => ({
    ...initialState.checkin,
    // isGenericCheckin: state.isGenericCheckin,
  }),
  [types.CHECKINAUTH]: (state, action) => ({
    ...state,
    // isAdditionalDriver: action.payload.isAdditionalDriver,
    // resNo:action.payload.bookingNumber,
    loading: true,
  }),
  [types.CHECKINAUTH_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      token: action.response.token,
      expires: moment().add(10, "m").unix(),
      success: true,
    },
    loading: false,
  }),
  [types.CHECKINAUTH_FAILURE]: (state) => ({
    ...state,
    loading: false,
  }),

  [types.GET_UPCOMING_OCRLABS_OUTAGE_SUCCESS]: (state, action) => ({
    ...state,
    ocrLabsOutage: action.response.data.GetUpcomingOcrLabsOutage,
  }),

  [types.ID_VERIFICATION_SKIPPED]: (state, action) => ({
    ...state,
    idVerificationSkipped: true,
  }),

  [types.ID_VERIFICATION_REQUIRED]: (state, action) => ({
    ...state,
    idVerificationSkipped: false,
  }),

  [types.ADDITIONAL_DRIVER_AUTH]: (state, action) => ({
    ...state,
    isAdditionalDriver: action.payload.isAdditionalDriver,
    resNo: action.payload.bookingNumber,
    loading: true,
  }),
  [types.ADDITIONAL_DRIVER_AUTH_SUCCESS]: (state, action) => ({
    ...state,
    auth: {
      token: action.response.token,
      expires: moment().add(10, "m").unix(),
      success: true,
    },
    loading: false,
  }),
  [types.ADDITIONAL_DRIVER_AUTH_FAILURE]: (state) => ({
    ...state,
    loading: false,
  }),

  [types.RETRIEVERESERVATION]: (state) => ({
    ...state,
    loading: true,
  }),
  [types.RETRIEVERESERVATION_SUCCESS]: (state, action) => ({
    ...state,
    reservation: action.response.data.WebRetrieveReservation,
    loading: false,
  }),
  [types.RETRIEVERESERVATION_FAILURE]: (state) => ({
    ...state,
    reservation: {},
    loading: false,
  }),
  [types.RETRIEVECUSTOMER]: (state) => ({
    ...state,
    loading: true,
  }),
  [types.RETRIEVECUSTOMER_SUCCESS]: (state, action) => ({
    ...state,
    customer: action.response.data.WebRetrieveReservation,
    loading: false,
  }),
  [types.RETRIEVECUSTOMER_FAILURE]: (state) => ({
    ...state,
    customer: {},
    loading: false,
  }),
  [types.SAVERESERVATIONOPTIONS]: (state, action) => ({
    ...state,
    reservation: {
      ...state.reservation,
      Options: action.payload.Options,
    },
  }),
  [types.RESESTIMATE_SUCCESS]: (state, action) => ({
    ...state,
    estimate: action.response.data.WebResEstimate,
  }),

  [types.FRONTDESKRESESTIMATE_SUCCESS]: (state, action) => ({
    ...state,
    estimate: action.response.data.FrontdeskGetEstimate,
  }),
  [types.FRONTDESKRESESTIMATE_FAILURE]: (state, action) => ({
    ...state,
    toast: {
      type: "error",
      message: "Failed to get the Estimates",
    },
  }),
  [types.RESOPTIONS_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    options: action.response.data.WebResOptions,
  }),
  [types.RESESTIMATE_FAILURE]: (state, error) => ({
    ...state,
    loading: false,
    error: error,
    estimate: {},
  }),
  [types.GETDETAILS_SUCCESS]: (state, action) => ({
    ...state,
    details: action.response.data,
  }),
  [types.GETDETAILS_FAILURE]: (state, action) => ({
    ...state,
    toast: {
      type: "error",
      message: "Failed to Fetch Data please try again later",
    },
  }),
  [types.DELETE_TOAST]: (state) => ({
    ...state,
    toast: { type: "", message: "" },
  }),
  [types.SEARCHCUSTOMER]: (state, action) => ({
    ...state,
    loading: true,
    licCountry: action.payload.country,
    LicenceNumber: action.payload.licNo,
    resNo: action.payload.resNo,
  }),
  [types.SEARCHCUSTOMER_SUCCESS]: (state, action) => {
    const idvRecord = action.response.data.FrontdeskSearchCustomer.IdVerification;
    const hasValidResult = idvRecord?.Status == "COMPLETED_PASS" || "COMPLETED_DVS";
    const hasPendingResult = idvRecord?.Status == "PENDING";

    return {
      ...state,
      customer: action.response.data.FrontdeskSearchCustomer,
      idVerification: hasValidResult || hasPendingResult ? idvRecord : {},
      hasValidResult,
      loading: false,
      toast: !action.response.data.FrontdeskSearchCustomer.Success
        ? {
            type: "error",
            message: action.response.data.FrontdeskSearchCustomer.Error,
          }
        : state.toast,
    };
  },
  [types.SEARCHCUSTOMER_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    toast: {
      type: "error",
      message: "Sorry, no matching customer details found",
    },
  }),

  [types.SEND_SMS_INVITE]: (state, action) => ({
    ...state,
    smsInviteSentSuccess: null,
    smsInviteResMessage: null,
    sendingSMS: true,
    finalPageSMSSent: action.payload.finalPageSMSSent
  }),

  [types.SEND_SMS_INVITE_SUCCESS]: (state, action) => {
    return {
      ...state,
      smsInviteSentSuccess: action.response.data.SendAddDriverSMSInvite.Success,
      smsInviteResMessage: action.response.data.SendAddDriverSMSInvite.Messages,
      sendingSMS: false,
    };
  },
  [types.SEND_SMS_INVITE_FAILURE]: (state, action) => ({
    ...state,
    sendingSMS: false,
    toast: {
      type: "error",
      message: "Sorry, SMS invite to addtional driver failed",
    },
  }),

  [types.UPDATECUSTOMERCONTACT]: (state, action) => ({
    ...state,

    reservation: {
      ...state.reservation,
      Renter: {
        ...state.reservation.Renter,
        Address: {
          ...state.reservation.Renter?.Address,
          Email: action.payload.email,
          HomeTelephoneNumber: action.payload.phoneNumber,
          CellTelephoneNumber: action.payload.alternatePhone,
          RegionOfIssue: action.payload.regionOfIssue
        },
      },
    },
  }),

  [types.SET_CHECKIN_DEMO]: (state, action) => ({
    ...state,
    isDemo: action.payload.isDemo,
  }),

  [types.RESETVERIFYSTATUS]: (state, action) => ({
    ...state,
    windcave: {},
    idVerification: {},
  }),

  [types.RESET_ID_VERIFY_STATUS]: (state, action) => ({
    ...state,
    idVerification: {},
  }),

  [types.SET_REQUIRE_REVERIFY_CC]: (state, action) => ({
    ...state,
    requireReVerifyCC: action.payload.requireReVerifyCC,
  }),

  [types.SET_REQUIRE_REVERIFY_ID]: (state, action) => ({
    ...state,
    requireReVerifyID: action.payload.requireReVerifyID,
  }),

  [types.UPDATERESERVATIONANDCUSTOMER_CIF]: (state) => ({
    ...state,
    // loading: true,
  }),
  [types.UPDATERESERVATIONANDCUSTOMER_CIF_SUCCESS]: (state, action) => {
    const currentMainNote = state.reservation.ReservationMainNote;
    const newNote = currentMainNote.slice(0, currentMainNote.indexOf("|CI")) + "|CIF|";
    return {
      ...state,
      // loading: false,
      checkinComplete: true,
      reservation: { ...state.reservation, ReservationMainNote: newNote },
    };
  },
  [types.UPDATERESERVATIONANDCUSTOMER_CIF_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
  }),

  [types.CREATE_CUSTOMER]: (state) => ({
    ...state,
    loading: true,
  }),

  [types.CREATE_CUSTOMER_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    additionalDriverVoidCompleted: true,
  }),

  [types.CREATE_CUSTOMER_FAILURE]: (state) => ({
    ...state,
    loading: false,
  }),

  [types.MANUAL_CREATE_CUSTOMER_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    customer: {
      LatestCustomer: {
        customerNumber: action.response.data.FrontdeskCreateCustomer.CustomerNumber,
      },
    },
  }),

  [types.UPDATE_CUSTOMER]: (state) => ({
    ...state,
    // loading: true,
  }),

  [types.UPDATE_CUSTOMER_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    additionalDriverVoidCompleted: true,
  }),

  [types.UPDATE_CUSTOMER_FAILURE]: (state) => ({
    ...state,
    loading: false,
  }),

  [types.UPDATERESERVATIONANDCUSTOMER]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.UPDATERESERVATIONANDCUSTOMER_SUCCESS]: (state, action) => {
    const currentMainNote = state.reservation.ReservationMainNote;
    const newNote = currentMainNote.slice(0, currentMainNote.indexOf("|CI")) + "|CIP|";
    return {
      ...state,
      loading: false,
      reservation: { ...state.reservation, ReservationMainNote: newNote },
      checkinComplete: action?.response?.data?.FrontdeskUpdateReservationAndCustomer?.Success,
    };
  },
  [types.UPDATERESERVATIONANDCUSTOMER_FAILURE]: (state, action) => ({
    ...state,
    toast: {
      type: "error",
      message:
        "We are unable to complete your request at the moment. If you continue to experience issues please head to the counter on arrival to complete the check-in process.",
    },
    loading: false,
  }),
  [types.SEARCHADDRESS_SUCCESS]: (state, action) => {
    const addressSuggestions = [];
    _.get(action, "response.data.KleberDataValidation.AddressResult", []).forEach((address) => {
      if (
        _.get(action, "response.data.KleberDataValidation.International", false) &&
        (_.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") != "AU" ||
          _.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") != "NZ")
      ) {
        addressSuggestions.push({
          label: _.get(address, "AddressLine", ""),
          value: _.get(address, "RecordId", null),
        });
      } else if (
        _.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") == "NZ"
      ) {
        addressSuggestions.push({
          label:
            _.get(address, "AddressLine", "") +
            " " +
            _.get(address, "Suburb", "") +
            ", " +
            _.get(address, "TownCityMailtown", "") +
            ", " +
            _.get(address, "Postcode", ""),
          value: _.get(address, "RecordId", null),
        });
      } else if (
        _.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") == "AU"
      ) {
        addressSuggestions.push({
          label:
            _.get(address, "AddressLine", "") +
            ", " +
            _.get(address, "Locality", "") +
            ", " +
            _.get(address, "Postcode", "") +
            ", " +
            _.get(address, "State", ""),
          value: _.get(address, "RecordId", null),
        });
      }
    });
    return {
      ...state,
      addressSuggestions: addressSuggestions,
    };
  },
  [types.RETRIEVEADDRESS_SUCCESS]: (state, action) => {
    return {
      ...state,
      selectedAddress: {
        address: _.get(
          action,
          "response.data.KleberDataValidation.AddressResult[0]",
          initialState.checkin.selectedAddress
        ),
        selectedCountry: _.get(
          action,
          "response.data.KleberDataValidation.SuggestionCountry",
          initialState.checkin.selectedAddress
        ),
      },
    };
  },
  [types.SENDNOTIFICATION_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    notificationSent: true,
  }),
  [types.EXTEND_SESSION]: (state, action) => ({
    ...state,
    auth: {
      ...state.auth,
      expires: moment()
        .add(action.payload != undefined ? action.payload.mins : 5, "m")
        .unix(),
    },
  }),
  [types.LOGOUT]: (state) => ({
    ...state,
    auth: {
      success: false,
      token: "",
      expires: "",
      success: false,
    },
    reservation: {},
    customer: {},
    estimate: {},
    options: {},
    details: {},
    isDemo: state.isDemo,
    isGenericCheckin: state.isGenericCheckin,
    toast: { type: "", message: "" },
  }),
  [types.REQUEST_WINDCAVEHPP]: (state, action) => ({
    ...state,
    requireReVerifyCC: false,
    loading: true,
  }),
  [types.REQUEST_WINDCAVEHPP_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,

    windcave: { ...state.windcave, ...action.response.data.WindcaveCreateSession },
  }),
  [types.REQUEST_WINDCAVEHPP_FAILURE]: (state) => ({
    ...state,
    toast: {
      type: "error",
      message:
        "We are unable to complete your request at the moment, please try again in a few minutes time",
    },
    loading: false,
  }),
  [types.WINDCAVE_UPDATE]: (state, action) => ({
    ...state,
    windcave: { ...state.windcave, ...action.payload },
  }),
  [types.WINDCAVE_SKIP]: (state, action) => ({
    ...state,
    windcave: { ...state.windcave, Windcave: { status: "APPROVED" } },
  }),
  [types.CREATE_TOAST]: (state, action) => ({
    ...state,
    toast: {
      type: action.payload.type,
      message: action.payload.message,
    },
  }),
  [types.WINDCAVE_STATUS]: (state) => ({
    ...state,
    loading: true,
  }),
  [types.WINDCAVE_STATUS_SUCCESS]: (state, action) => {
    let nameMisMatch;
    if (action.response.data.WindcaveValidateCreditCard.Success) {
      const cardHolderName =
        action.response.data.WindcaveValidateCreditCard.Windcave.transactions[0].card
          .cardHolderName;
      const renterLastName = state.reservation.Renter.RenterName.lastName;
      const renterFirstName = state.reservation.Renter.RenterName.firstName;

      if (
        cardHolderName.trim().includes(renterLastName.trim()) &&
        cardHolderName.trim().includes(renterFirstName.trim())
      ) {
        nameMisMatch = false;
      } else if (
        cardHolderName.trim().includes(renterLastName.trim()) &&
        cardHolderName.trim().substring(0, 1).includes(renterFirstName.trim().substring(0, 1))
      ) {
        nameMisMatch = false;
      } else if (
        cardHolderName.trim().includes(renterLastName.trim()) &&
        !cardHolderName.trim().includes(renterFirstName.trim())
      ) {
        nameMisMatch = true;
      } else {
        nameMisMatch = true;
      }
    }

    return {
      ...state,
      loading: false,
      windcave: {
        ...state.windcave,
        nameMisMatch,
        ...action.response.data.WindcaveValidateCreditCard,
      },
      toast:
        nameMisMatch && state.toast.message == ""
          ? {
              type: "error",
              message: "Card holder name does not match reservation name.",
            }
          : state.toast,
    };
  },
  [types.WINDCAVE_STATUS_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    windcave: { ...state.windcave, ...action.response.data.WindcaveValidateCreditCard },
  }),

  [types.REQUEST_IDVERIFICATION_TRANSACTION]: (state, action) => ({
    ...state,
    idVerification: {},
    loading: true,
  }),
  [types.REQUEST_IDVERIFICATION_TRANSACTION_SUCCESS]: (state, action) => ({
    ...state,
    idVerification: { ...state.idVerification, ...action.response.data.IdVerification },
    loading: false,
  }),
  [types.REQUEST_IDVERIFICATION_TRANSACTION_FAILURE]: (state) => ({
    ...state,
    toast: {
      type: "error",
      message:
        "We are unable to complete your request at the moment, please try again in a few minutes time",
    },
    loading: false,
  }),

  [types.REQUEST_IDVERIFICATION_STATUS]: (state, action) => ({
    ...state,
    loading: true,
    idVerification: { ...state.idVerification, fetchingIdvStatus: true },
  }),
  [types.REQUEST_IDVERIFICATION_STATUS_SUCCESS]: (state, action) => {
    const failReasons = [];

    if (action.response.data.IdVerificationQueryTransaction.Success) {
      const idvDetails = action.response.data.IdVerificationQueryTransaction.TransactionDetails;
      const resRenterName = state.reservation.Renter?.RenterName;

      const dlExpired = Date.parse(idvDetails.DateOfExpiry) < Date.now();

      if (idvDetails.OverallResult != "PASS") {
        failReasons.push("OverallFail");
      }

      if (idvDetails.FaceMatch != "PASS") {
        failReasons.push("FaceMatch");
      }

      if (idvDetails.Liveness != "PASS") {
        failReasons.push("Liveness");
      }

      if (!idvDetails.Over21) {
        failReasons.push("Over21");
      }

      // console.log("idvDetails.DVS: ", idvDetails.DVS);
      // if (idvDetails.DVS === 'D') {
      //   failReasons.push("DVS");
      // }

      if (dlExpired) {
        failReasons.push("dlExpired");
      }
      if (!state.isAdditionalDriver && !_.isEmpty(resRenterName) && !_.isEmpty(idvDetails)) {
        //compare lastname and first letter of firstname
        if (
          (!resRenterName.lastName
            .replace(/[^A-Z0-9]/gi, "")
            .toUpperCase()
            .includes(idvDetails.LastName.replace(/[^A-Z0-9]/gi, "").toUpperCase()) &&
            !idvDetails.LastName.replace(/[^A-Z0-9]/gi, "")
              .toUpperCase()
              .includes(resRenterName.lastName.replace(/[^A-Z0-9]/gi, "").toUpperCase())) ||
          (!idvDetails.FirstName.replace(/[^A-Z0-9]/gi, "")
            .substring(0, 1)
            .toUpperCase()
            .includes(
              resRenterName.firstName
                .replace(/[^A-Z0-9]/gi, "")
                .substring(0, 1)
                .toUpperCase()
            ) &&
            !resRenterName.firstName
              .replace(/[^A-Z0-9]/gi, "")
              .substring(0, 1)
              .toUpperCase()
              .includes(
                idvDetails.FirstName.replace(/[^A-Z0-9]/gi, "")
                  .substring(0, 1)
                  .toUpperCase()
              ))
        ) {
          failReasons.push("Name");
        }
      }
      if (idvDetails.DocumentVariant && idvDetails.DocumentVariant === "LEARNERS") {
        failReasons.push("Learner");
      }

      return {
        ...state,
        // requireReVerifyID:false,
        idVerification: {
          ...state.idVerification,
          Verified: true,
          fetchingIdvStatus: false,
          fetchFailed: false,
          ...action.response.data.IdVerificationQueryTransaction.TransactionDetails,
          failReasons,
          completionTime: action.response.data.IdVerificationQueryTransaction.CompletedAt,
        },
        loading: false,
      };
    } else {
      const now = moment();
      const diff = now.diff(
        action.response.data.IdVerificationQueryTransaction.CompletedAt,
        "seconds"
      );
      // Time out idverifiation pending status after 2 minutes of completing idverification
      if (diff > 120) {
        failReasons.push("FailedToFinaliseIdverification");
      } else {
        failReasons.push("FetchFailed");
      }
      return {
        ...state,
        idVerification: {
          ...state.idVerification,
          fetchingIdvStatus: false,
          fetchFailed: true,
          failReasons,
          completionTime: action.response.data.IdVerificationQueryTransaction.CompletedAt,
        },
        loading: false,
      };
    }
  },
  [types.REQUEST_IDVERIFICATION_STATUS_FAILURE]: (state) => ({
    ...state,
    idVerification: {
      ...state.idVerification,
      fetchingIdvStatus: false,
      fetchFailed: true,
      failReasons: ["FetchFailed"],
    },
    // toast: {
    //   type: "error",
    //   message:
    //     "We are unable to complete your request at the moment, please try again in a few minutes time",
    // },
    loading: false,
  }),

  [types.IDV_SKIP]: (state, action) => ({
    ...state,
    idVerification: { ...state.idVerification, Verified: true },
  }),

  [types.GET_BRAND_LOCATIONS]: (state, action) => ({
    ...state,
    loading: true,
  }),
  [types.GET_BRAND_LOCATIONS_SUCCESS]: (state, action) => ({
    ...state,
    brandLocations: action.response.data.GetBrandLocationsLean,
    loading: false,
  }),
  [types.GET_BRAND_LOCATIONS_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    toast: {
      type: "error",
      message: "Failed to get the Brand Locations",
    },
  }),
});

export default checkinReducer;
